<template>
  <section>
    <b-card>
      <template #header>
        <div class="d-flex align-items-center">
          <span class="text-primary">Gestione Servizi </span>
          <b-breadcrumb class="ml-2">
            <b-breadcrumb-item>
              <feather-icon
                icon="HomeIcon"
                scale="1.25"
                shift-v="1.25"
              ></feather-icon>
            </b-breadcrumb-item>
            <b-breadcrumb-item active> Elenco Servizi</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
        <div>
          <b-button variant="primary" @click="$refs.serviceAddModal.open()">
            Aggiungi Servizio
          </b-button>
        </div>
      </template>

      <b-row class="mt-2">
        <b-col md="9"> </b-col>

        <b-col md="3">
          <div class="d-flex align-items-center mb-2">
            <span class="mr-1">Cerca</span>
            <b-form-input type="text" v-model="filter" size="md" debounce="500"/>
          </div>
        </b-col>
      </b-row>

      <b-table
        :fields="fields"
        :items="serviceProvider"
        :busy="loading"
        :current-page="currentPage"
        :filter="filter"
        striped
        show-empty
        responsive
        @sort-changed="sortTable"
      >
        <template #table-busy>
          <div class="text-center text-primary-light my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Caricamento dati dei servizi...</strong>
          </div>
        </template>

        <template #empty>
          <h5 class="text-primary-light text-center my-2">
            Non ci sono servizi
          </h5>
        </template>

        <template #emptyfiltered>
          <h5 class="text-primary-light text-center my-2">
            Non sono stati trovati servizi
          </h5>
        </template>

        <template #cell(service_status)="data">
          <b-badge
            :variant="
              data.item.service_status == 'Attivo' ? 'success' : 'danger'
            "
            v-html="
              data.item.service_status == 'Attivo' ? 'Attivo' : 'Non Attivo'
            "
          />
        </template>

        <template #cell(opzioni)="data">
          <feather-icon
            class="cursor-pointer"
            icon="EditIcon"
            size="20"
            @click="$refs.serviceEditModal.open(data.item)"
            v-b-tooltip.hover.top.v-primary-light="'Modifica'"
          />
        </template>
      </b-table>

      <b-pagination
        v-if="services.count > perPage"
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="services.count"
        align="right"
        size="sm"
        class="my-0"
      />
    </b-card>

    <!-- Modali -->

    <service-add-modal ref="serviceAddModal" @hide="getServices"/>
    <service-edit-modal ref="serviceEditModal" />
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BBadge,
  BButton,
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BTable,
  BSpinner,
  BFormInput,
  BPagination,
  VBTooltip,
} from "bootstrap-vue";

import { ServiceAddModal, ServiceEditModal } from "@/components/modals";

import { Requests } from "@/api";

export default {
  components: {
    BRow,
    BCol,
    BBadge,
    BButton,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BTable,
    BSpinner,
    BFormInput,
    BPagination,
    ServiceAddModal,
    ServiceEditModal,
  },

  directives: {
    "b-tooltip": VBTooltip,
  },

  data: () => ({
    fields: [
      {
        key: "service_name",
        label: "Nome Servizio",
        sortable: true,
      },
      {
        key: "service_status",
        label: "Stato Servizio",
        sortable: true,
      },
      {
        key: "opzioni",
        sortable: false,
      },
    ],

    filter: null,
    sortBy: "service_name",
    sortDesc: false,
    services: [],

    //Helpers

    perPage: 10,
    currentPage: 1,
    loading: false,
  }),

  methods: {
    async getServices(page) {
      this.loading = true;

      page = page ?? this.currentPage;

      let request_data = new FormData();

      request_data.append("offset", (page - 1) * this.perPage);
      request_data.append("limit", this.perPage);
      request_data.append("filter", this.filter);
      request_data.append("sortBy", this.sortBy);
      request_data.append("sortDesc", this.sortDesc);

      try {
        const response = await Requests.getServices(request_data);
        this.services = response;
      } catch (err) {
        console.debug(err);
      }

      this.loading = false;
    },

    async serviceProvider(ctx) {
      await this.getServices();
      return this.services.data;
    },

    async sortTable(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
    },
  },
};
</script>
